export default "__VITE_ASSET__CO$paLC$__"